import View from './view';
import previewView from './previewView';
import icons from 'url:../../img/icons.svg'; // Parcel 2

class bookmarksView extends View {
  _parentElement = document.querySelector(`.bookmarks__list`);
  _errorMessage = `No bookmarks yet. find a nice recipe and bookmark it ;)`;
  _message = ` `;

  addHandlerRender(handler) {
    window.addEventListener(`load`, handler);
  }

  _generateMarkup() {
    return this._data
      .map(bookmark => previewView.render(bookmark, false))
      .join('');
  }
}

export default new bookmarksView();
